define(function(require) {
  // general
  const CN = require('civicsUtils/constants');
  const CommonReviewCode = require('civicsViews/assign_review/common/common');
  // templates
  const tpl = require('civicsViews/code_violations/templates/t_cpv_violations.hbs');
  // views
  const itemView = require('civicsViews/code_violations/v_itv_violation_item');

  return Marionette.CompositeView.extend({
    initialize: function(options) {
      this.config = options.config;
      this.currentSort = options.currentSort;
      this.showAllItems = options.showAllItems;
      this.expanded = options.expanded;
      this.collection = options.collection;
    },
    template: tpl,
    tagName: 'div',
    childView: itemView,
    className: 'collapsible-wrapper',
    ui: {
      moreContent: '.view-more',
    },
    childViewContainer: function() {
      // The target (in the composite view) for the item rows
      return '.activity-violations-item-view';
    },
    childViewOptions: function(model, index) {
      return {
        config: this.config,
        showAllItems: this.showAllItems,
        index: index,
        expanded: this.expanded,
        collection: this.collection
      };
    },
    events: {
      'click @ui.btnSortResolution': 'sortByResolutionClicked',
    },
    onRender: function() {
      if (__DEV__) console.log('cpv_violations onRender');
      if (this.collection.length <= 3) {
        this.ui.moreContent.hide();
      }
      this.$el.rhythmThemeInit();
    },
    templateHelpers: function() {
      var self = this;
      var helpers = {
        showComments: function() {
          return !self.config.isPublic;
        },
      };
      return helpers;
    },
  });
});
